import React from "react";

const UserContext = React.createContext({
  user: null,
  isNonDeniedAgencyUser: false,
  isSignedIn: false,
});
UserContext.displayName = "UserContext";

function UserProvider({ children }) {
  const uw211 = window.UW211 || {};

  const user = React.useMemo(() => {
    return uw211.CURRENT_USER || null;
  }, []);

  const value = React.useMemo(
    () => ({
      user,
      isNonDeniedAgencyUser: uw211.IS_NON_DENIED_AGENCY_USER || false,
      isSignedIn: !!user,
    }),
    [user, uw211.IS_NON_DENIED_AGENCY_USER]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

function useUser() {
  return React.useContext(UserContext);
}

export { UserContext, UserProvider, useUser };
